import styled from "@emotion/styled";
import { colors } from "../../../styles/colors";
import { fonts } from "../../../styles/fonts";

export const AdditionalWrap = styled.section`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  max-width: 1440px;
  width: 100%;
  margin: 60px auto 0;
  @media (max-width: 769px) {
    text-align: center;
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 68px;
  margin: 68px -2.488% 0;
  @media (max-width: 769px) {
    flex-direction: column;
    margin-top: 38px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: 769px) {
    flex: 0 0 33.333%;
    max-width: 33.333%;
    padding: 0 2.488%;
  }
  img {
    display: block;
    margin: 0 auto 3px;
  }
`;

export const Title = styled.h2`
  font-size: 48px;
  line-height: 57px;
  color: ${colors.GREY_DARK};
  font-family: ${fonts.abhayaBold};
  margin-bottom: 9px;
  @media (max-width: 769px) {
    font-size: 36px;
    line-height: 42px;
  }
`;
export const FeatureTitle = styled.h3`
  font-size: 16px;
  margin-bottom: 5px;
`;

export const Text = styled.p`
  color: ${(props) => (props.textColor === `GREY` ? `${colors.GREY}` : `${colors.GREY_SEMIDARK}`)};
  font-family: ${fonts.latoRegular};
  line-height: 27px;
  max-width: 463px;
  text-align: center;
  margin: 0;
  + p {
    margin-top: 6px;
  }
`;
